module.exports = __webpack_public_path__ + "7536312ccbbb43e34347dde00dabae37.pdf";